import React, { FC, ReactElement, useState } from 'react';
import classNames from 'classnames/bind';
import Link from 'next/link';
import styles from 'sections/Resources/FreightDictionary/components/SectionTerms/SearchPanel/SearchTags/Tag/Tag.module.scss';

const cn = classNames.bind(styles);

type Tag = {
  tagText: string;
  customStyles?: any;
  isActive: boolean;
  onTagClick: () => void,
}

const Tag: FC<Tag> = ({ tagText, customStyles, isActive, onTagClick }: Tag): ReactElement => {
  return (
    <Link
      className={cn('tag', { 'is-active': isActive })}
      style={customStyles ? customStyles.container : {}}
      href={`#${tagText}`}
      onClick={onTagClick}
    >
      <span className={cn('tag__name')}>{tagText}</span>
    </Link>
  );
};

export { Tag };